export const ROOT_ID = 'wptelegram-login-settings';
